import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gPdf from "@/components/g-pdf/g-pdf";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import ReclamacaoTecnicaController from "@/shared/controllers/reclamacaoTecnica/reclamacaoTecnicaController";
import FiltroConsultarReclamacoes from "@/shared/view-models/Filtros/FiltroConsultarReclamacoes";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import RepresentanteController from "@/shared/controllers/representante/representanteController";
import ReclamacaoTecnicaComercialPDF from "./components/PDF/ReclamacaoTecnicaComercialPDF.vue";



const name = 'ReclamacaoTecnicaComercial'
export default {
  name,

  components: {
    'g-card': gCard,
    'g-form': gForm,
    'g-date-input':gDateInput,
    'g-button': gButton,
    'g-data-table': gDataTable,
    'g-pdf': gPdf,
    ReclamacaoTecnicaComercialPDF
  },

  props: { },

  mounted () {
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.EmpresaArrayPopup = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.popularDropDownEmpresa()
    this.atualizaEmpresaRepresentante()
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
  },

  updated () { },

  data () {
    return {
      RepresentanteSelecionado:null,
      EmpresaSelecionada:undefined,
      ClienteSelecionado:null,
      RepresentantesArray: [],
      ClienteArray: [],
      ClienteId: null,
      EmpresaArray: [],
      EmpresaArrayPopup: [],
      ReclamacaoArray: [],
      ReclamacaoTecnicaId: null,
      executarvisualizacao: 0,
      renderiza: false,
      checkboxConsultarDados: false,
      informacaoCartPropSelecionada: null,
      mensagemvazio: true,
      objFiltros: new FiltroConsultarReclamacoes(),
      popup: false,
      Colunas: [
        {field: 'codigoReclamacao', header: 'Número'},
        {field: 'nomeUnidade', header: 'Unidade'},
        {field: 'nomeContato', header: 'Cliente', width: '350px'},
        {field: 'numeroPedido', header: 'Pedido'},
        {field: 'nomeUsuario', header: 'Usuário'},
        {field: 'nomeRepresentante', header: 'Representante'},
        {field: 'dataInclusaoFormatada', header: 'Data / Hora'},
      ],
      Filtro: {
        'global': {value: null, matchMode: this.filtros.CONTAINS},
        'codigoReclamacao': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeUnidade': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeContato': {value: null, matchMode: this.filtros.CONTAINS},
        'numeroPedido': {value: null, matchMode: this.filtros.CONTAINS},
        'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
        'dataInclusaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
      },
      timer: null,
    }
  },

  methods: {
    imprimir(data)
    {
      this.renderiza = true
      this.ReclamacaoTecnicaId = data.id
      this.executarvisualizacao++
    },
    Grid() {
      this.GetReclamacaoByFiltro()
    },
    valida(){
      if(this.ClienteSelecionado != null && this.RepresentanteSelecionado != null){
        this.iniciaFormulario()
        }
      else{
        this.$toast.add({ severity: 'error', summary: 'Erro ao preencher dados', detail: 'Cliente, Unidade e Representante são campos obrigatórios', life: 5000 });
      }
    },
    iniciaFormulario(){
     this.axios({
        method: 'Post',
        url: process.env.VUE_APP_WEB_API +  `reclamacao/GetInfoFormulario`,
        data: {
          Id: this.ClienteSelecionado,
          EmpresaId: this.EmpresaSelecionada
        }
      })
      .then((response) => {
        this.infoFormulario = response.data.data
        this.$router.push(`/formulario/${this.ClienteSelecionado}/${this.EmpresaSelecionada}/${this.RepresentanteSelecionado}/`)
      })
      .catch(() => {
      })
    },
    abrePopup () {
      this.popup=true
    },
    fechaPopup(){
      this.popup = false,
      this.ClienteSelecionado = '',
      this.EmpresaSelecionada = '',
      this.RepresentanteSelecionado = ''
    },

    GetReclamacaoByFiltro() {
      this.$isLoading(true)
      ReclamacaoTecnicaController.GetReclamacaoByFiltro(this.objFiltros).requisicao
      .then(response => {
        this.ReclamacaoArray = response.data.data;
        this.mensagemvazio = false
      })
      .finally(() => {
        this.$isLoading(false)
      })
    },

    clear() {
      this.objFiltros = new FiltroConsultarReclamacoes();

      this.ClienteArray = []
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.UnidadeArray = response.data.data
      })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },

    buscarClientes(event) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.objFiltros.UnidadeId, event).ClientesArray;
      }, 1000);
    },

    buscarRepresentante(event) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisaEUsuario(event).RepresentanteArray;
      }, 1000);
    },

    procurarRepresentante() {
      this.popularDropDownRepresentante()
    },

    atualizaEmpresaRepresentante() {
      this.EmpresaSelecionada = this.$store.state.empresaSelecionadaId;
      this.RepresentantesArray = this.$store.state.RepresentanteArray;
      this.RepresentanteSelecionado = this.$store.state.representanteSelecionadoId;
      this.objFiltros.RepresentanteId = this.$store.state.representanteSelecionadoId;
    },

    popularDropDownEmpresa() {
      this.EmpresaArray = this.$store.state.EmpresaArray;
      //this.atualizaEmpresaRepresentante()
    },

    detalhesReclamacoesTecnicas(data) {
      const rotaNovaAbaURL = this.$router.resolve({
        path: `/detalhes-reclamacao-tecnica/${data.id}`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    }
  }
};